<!--Responsive Language for Mobile-->
<div *ngIf="isMobile" class="container mobile-lang-menu">
    <section class="region region-top-header-form">
        <div class="language-switcher-language-url block block-language block-language-block-language-interface block-un3-sc-languageswitcher collapse" id="block-un3-sc-languageswitcher" role="navigation">
            <div class="block-content">
            <ul class="links nav">
                <li hreflang="ar" >
                    <a (click)="changeLang('ar')" [class.is-active]="lang === 'ar'" class="language-link nav-link" hreflang="ar" >العربية</a>
                </li>
                <li hreflang="zh-hans">
                    <a (click)="changeLang('zh')" [class.active]="lang === 'zh'" class="language-link nav-link" hreflang="zh-hans" >中文</a>
                </li>
                <li hreflang="en">
                    <a (click)="changeLang('en')" [class.active]="lang === 'en'" class="language-link nav-link" hreflang="en"  aria-current="page">English</a>
                </li>
                <li hreflang="fr"  >
                    <a (click)="changeLang('fr')" [class.active]="lang === 'fr'" class="language-link nav-link" hreflang="fr" >Français</a>
                </li>
                <li hreflang="ru">
                    <a (click)="changeLang('ru')" [class.active]="lang === 'ru'" class="language-link nav-link" hreflang="ru" >Русский</a>
                </li>
                <li hreflang="es">
                    <a (click)="changeLang('es')" [class.active]="lang === 'es'" class="language-link nav-link" hreflang="es" >Español</a>
                </li>
            </ul>
            </div>
        </div>
    </section>
</div>
